import { Component, Input, ViewChild } from '@angular/core';
import { QuestionsService } from '_services/questions.service';
import { CalcConfigService } from '_services/calc-config.service';
import { Condition } from '../../_models/population';
import { Table } from '../../_models/table';
import { Rule } from '../../_models/package';
import { Question } from 'app/_models/question';
import { AsyncPipe } from '@angular/common';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { KeySelectComponent } from '../key-select/key-select.component';

// Used by Formula
export interface Part {
  math: string;
  type: 'Question' | 'Calculation' | 'Table' | 'New';
  question?: Question;
  keyId?: string; // e.x. maps to questionId if NPCInput
  tableId?: string;
  value: number;
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'input-selector',
    templateUrl: './input-selector.component.html',
    styleUrls: ['./input-selector.component.css'],
    imports: [MatFormField, MatLabel, MatSelect, MatOption, KeySelectComponent, AsyncPipe]
})
export class InputSelectorComponent {

  @Input({ required: true }) key!: Part | Condition | Table | Rule;
  @Input({ required: true }) caller!: 'Population' | 'Package' | 'Table' | 'Formula';

  @ViewChild(MatSelect) inputTypeSelect?: MatSelect;

  asPart(val: Part | Condition | Table | Rule): Part { return val as Part; }
  asTable(val: Part | Condition | Table | Rule): Table { return val as Table; }
  asRule(val: Part | Condition | Table | Rule): Rule { return val as Rule; }

  constructor(
    public qs: QuestionsService,
    public cc: CalcConfigService
  ) { }

  focus() {
    if (this.inputTypeSelect) {
      this.inputTypeSelect.focus();
    }
  }

  setKey(event: string) {
    this.key.keyId = event;
  }

  getQuestionName(qId: string): string {
    const q = this.qs.getQuestion(qId);
    return q ? q.label : '';
  }

  getFormulaName(formulaId: string): string {
    const f = this.cc.getFormula(formulaId);
    return f ? f.name : '';
  }

  getTableName(tableId: string): string {
    const t = this.cc.getTable(tableId);
    return t ? t.name : '';
  }


  setFormula(formulaId: string) {
    (this.key as Rule).formula = this.cc.getFormula(formulaId);
  }

}
